import React from 'react';
import { BarChart3 } from 'lucide-react';

interface ProcessDataProps {
    apiResponse?: any;
}

export const ProcessData: React.FC<ProcessDataProps> = ({
    apiResponse,
}) => {
    // Get data from API only
    const jointCloseData = apiResponse?.jointCloseData;
    
    const displayData = {
        jointVolume: {
            actual: jointCloseData?.JointVolume ?? 0,
            unit: 'Litres',
        },
        chargeVolume: {
            actual: jointCloseData?.chargedVolume ?? 0,
            unit: 'Litres',
        },
        fillTime: {
            actual: jointCloseData?.fill_time ?? 0,
            unit: 'Seconds',
        },
        totalTime: {
            actual: jointCloseData?.totalTime ?? 0,
            unit: 'Seconds',
        },
    };

    return (
        <div className="bg-white rounded-lg border border-gray-200">
            <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-medium text-gray-900 flex items-center gap-2">
                    <BarChart3 className="h-5 w-5 text-blue-500" />
                    Process Data
                </h3>
            </div>
            <div className="p-6">
                {!jointCloseData ? (
                    <div className="text-center py-12 text-gray-500">
                        <BarChart3 className="h-12 w-12 mx-auto mb-4 text-gray-400" />
                        <p className="text-lg font-medium">No process data available</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-2 gap-4">
                        <div className="text-center p-4 bg-blue-50 rounded-lg border">
                            <div className="text-lg font-bold text-blue-700">
                                {displayData.jointVolume.actual} {displayData.jointVolume.unit}
                            </div>
                            <div className="text-xs text-blue-600 mt-1">Joint Volume</div>
                        </div>
                        <div className="text-center p-4 bg-green-50 rounded-lg border">
                            <div className="text-lg font-bold text-green-700">
                                {displayData.chargeVolume.actual} {displayData.chargeVolume.unit}
                            </div>
                            <div className="text-xs text-green-600 mt-1">Charge Volume</div>
                        </div>
                        <div className="text-center p-4 bg-purple-50 rounded-lg border">
                            <div className="text-lg font-bold text-purple-700">
                                {displayData.fillTime.actual} {displayData.fillTime.unit}
                            </div>
                            <div className="text-xs text-purple-600 mt-1">Fill Time</div>
                        </div>
                        <div className="text-center p-4 bg-orange-50 rounded-lg border">
                            <div className="text-lg font-bold text-orange-700">
                                {displayData.totalTime.actual} {displayData.totalTime.unit}
                            </div>
                            <div className="text-xs text-orange-600 mt-1">Total Time</div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

